import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BorrowerValuesListSmartComponent } from './borrower-values-list-smart.component';
import { DataListModule} from 'ng2-app/borrower-overview/data-list/data-list.module';
import { FormlyDialogModule } from 'ng2-app/components/formly-dialog/formly-dialog.module';
import { MatInputModule } from '@angular/material/input';
import { BorrowerDataTableModule } from 'app/borrower-data-table/borrower-data-table.module';
import { ErcDataTableComponent } from 'ng2-app/erc-application/erc-data-table/erc-data-table.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@NgModule({
  declarations: [
    BorrowerValuesListSmartComponent,
    ErcDataTableComponent
  ],
  imports: [
    CommonModule,
    DataListModule,
    FormlyDialogModule,
    MatInputModule,
    BorrowerDataTableModule,
    MatProgressSpinnerModule,
  ],
  exports: [
    BorrowerValuesListSmartComponent,
    ErcDataTableComponent
  ],
  providers: []
})
export class BorrowerValuesListSmartModule {}
